export default "__VITE_ASSET__bw9UT8xJ__"